import React, { useEffect } from 'react'
import SecondHeader from '../../components/SecondHeader/SecondHeader'
import CorProfileCard from '../../components/CorProfileCard/CorProfileCard'
import PastWork from '../../components/PastWork/PastWork'
import Footer from '../../components/Footer/Footer'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { ShowWorkersDetialAPI } from '../../redux/slices/SearchFilterSlice'

const CorporateProfile = () => {

    const dispatch = useDispatch();

    const singleWorker = useSelector(state => state.SearchFilterSlice.singleWorkerResult)

    const { id } = useParams();

    const fetchSingleWorkerDetails = async () => {
        try {
            await dispatch(ShowWorkersDetialAPI(id))
        } catch (error) {
            console.error("Unexpected Error:", error);
        }
    }

    useEffect(() => {
        fetchSingleWorkerDetails();
    }, [id])

    
    return (
        <>
            <SecondHeader />
            <CorProfileCard />
            {/* <PastWork /> */}
            <Footer />
        </>
    )
}

export default CorporateProfile